import React from "react";
import Grid from "@material-ui/core/Grid";

import Heading from "core/Heading";
import HeroCard from "./HeroCard";

import { MarketingPageSectionEyebrowSubheading } from "core/MarketingPageSectionHeading";
import { MaterialUIGridContainer } from "core/MaterialUI";
import {
    HeroSectionOuterContainer,
    HeroSectionInnerContainer,
    HeroCardsContainer,
    HeroContentContainer,
    DesktopLineBreak
} from "./styles";

import { heroCardData } from "./data";

const Hero = () => {
    return (
        <HeroSectionOuterContainer>
            <HeroSectionInnerContainer topSpacing="none" bottomSpacing="none">
                <HeroContentContainer>
                    <MarketingPageSectionEyebrowSubheading>
                        Noun Project
                    </MarketingPageSectionEyebrowSubheading>
                    <Heading type="h1" size="2xl" alignment="center">
                        Plans and Licenses for Art-Quality <DesktopLineBreak />
                        Icons and Photos
                    </Heading>
                    <HeroCardsContainer>
                        <MaterialUIGridContainer
                            mobileMaxPadding={3}
                            tabletMaxPadding={4}
                            desktopMinPadding={4}
                        >
                            {heroCardData.map(card => (
                                <Grid
                                    item
                                    sm={12}
                                    md={4}
                                    lg={4}
                                    key={card.title}
                                >
                                    <HeroCard
                                        title={card.title}
                                        description={card.description}
                                        highlights={card.highlights}
                                        icon={card.icon}
                                        sectionId={card.sectionId}
                                    />
                                </Grid>
                            ))}
                        </MaterialUIGridContainer>
                    </HeroCardsContainer>
                </HeroContentContainer>
            </HeroSectionInnerContainer>
        </HeroSectionOuterContainer>
    );
};

export default Hero;
